<template>
	<main>

		<header>
			<eia-heading level="h3">Proposal Type:</eia-heading>
			<eia-paragraph>{{ normalisedProposal }}</eia-paragraph>
		</header>

		<header>
			<eia-heading level="h3">Recommendation:</eia-heading>
			<eia-paragraph>{{ proposalRecommendation }}</eia-paragraph>
		</header>

		<header>
			<eia-heading level="h3">Summary Report</eia-heading>
			<eia-paragraph>The proposed development:</eia-paragraph>
		</header>

		<section>
			<div v-for="( value, key ) in calculationResults"
				:key="key"
				class="eia-stage-seven__result">
				<eia-icon
					class="result__icon"
					:name="value ? 'times' : 'check'"
					:variation="value ? 'danger' : 'success'">
				</eia-icon>
				<div>
					<eia-heading level="h4"
						:class="value ? 'danger' : 'success'">
						<span class="circle-disc"></span>
						<span>{{ getDisplayTitle( key, value ) }}</span>
					</eia-heading>
					<eia-accordion>
						<template slot="title">What does this mean?</template>
						<div class="outcome"
							v-html="getHelpText( key )"></div>
					</eia-accordion>
				</div>
			</div>
		</section>

		<section class="eia-stage-seven__what-next">
			<eia-heading level="h3">What happens next?</eia-heading>
			<eia-paragraph>
				You will receive an email summary of this EIA screening advice. If you would like further information, Quod's Environmental Planning team can provide a more detailed appraisal of your environmental site constraints and potential need for EIA as a supplementary informative for your enquiry. Additionally, if you would like more information about other planning services, including strategic planning advice, development economics and viability and socio-economic and health impact assessments, please get in touch.
			</eia-paragraph>
			<eia-paragraph>
				<em>Call us on:</em> <eia-link href="tel:02035971000">+44(0) 2035971000</eia-link>
			</eia-paragraph>
			<eia-paragraph>
				<em>Email us on:</em> <eia-link href="mailto:eiascreening@quod.com">eiascreening@quod.com</eia-link>
			</eia-paragraph>
		</section>
	</main>
</template>

<script>
import { mapState } from 'vuex';
import outcomes from '@/copy/outcomes';
import result from 'lodash.result';

export default {
	name: 'eia-stage-complete',

	props: {
		onReset: {
			type: Function,
		},
	},

	computed: {

		...mapState( 'stages', [
			'proposal',
			'responses',
			'outcome',
			'results',
			'calculationResults',
		] ),

		normalisedProposal() {
			//console.log( 'proposal', this.proposal );
			return result( this, 'proposal.description', this.proposal );
		},

		proposalRecommendation() {
			//console.log( 'outcome', this.outcome );
			return result( this, 'outcome.name', this.outcome );
		},
	},

	beforeMount(){

		// enable next button by sending a true response
		this.$emit( 'input', () => {
			if( this.onReset ){
				this.onReset();
			}
		} );

	},

	methods: {
		getDisplayTitle( key, is ) {
			return outcomes[ key ][ is ? 'yes' : 'no' ];
		},
		getHelpText( key ) {
			return outcomes[ key ].help;
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-stage-seven {
	&__result {
		display: grid;
		grid-template-columns: 1fr;
		margin: 0 0 16px 0;
	}

	.result__icon {
		font-size: $text-h1;

		&--error {
			color: $color-danger;
		}

		&--success {
			color: $color-success;
		}
	}

	&__what-next {
		margin-top: 32px;
	}
}

.eia-stage-seven__result {
	.eia-icon {
		display: none;
	}
	.eia-heading {
		display: flex;
		align-items: center;
		color: #25E064;
		&.danger {
			color: #E62A39;
			.circle-disc {
				border-color: #E62A39;
			}
		}
	}
	.circle-disc {
		margin-right: 20px;
		flex-shrink: 0;
		display: block;
		border-radius: 20px;
		border: 1px solid #25E064;;
		width: 10px;
		height: 10px;
	}
}

main {
	margin: 32px 0;

	header {
		margin-bottom: 32px;
	}
}
</style>
